// assets
import {
    IconDashboard,
    IconWallet,
    IconCar,
    IconUsers,
    IconUser,
    IconSettings,
    IconShieldCheck,
    IconMessageReport,
    IconTicket,
    IconCategory,
    IconTruckDelivery,
    IconArchive,
    IconReportAnalytics,
    IconHierarchy,
    IconLayoutGrid,
    IconReceipt2,
    IconListCheck,
    IconLayoutCards,
    IconFileText,
    IconSpeakerphone
} from '@tabler/icons';

// constant
const icons = {
    IconDashboard,
    IconWallet,
    IconCar,
    IconUsers,
    IconUser,
    IconSettings,
    IconShieldCheck,
    IconMessageReport,
    IconTicket,
    IconCategory,
    IconTruckDelivery,
    IconArchive,
    IconReportAnalytics,
    IconHierarchy,
    IconLayoutGrid,
    IconReceipt2,
    IconListCheck,
    IconLayoutCards,
    IconFileText,
    IconSpeakerphone
};

const prefix = '/admin';

const dashboard = {
    id: 'dashboard',
    title: 'Overview',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Analytics Home',
            type: 'item',
            url: `${prefix}/`,
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'reports-financial',
            title: 'Financial Performance',
            type: 'item',
            url: `${prefix}/reports/financial`,
            icon: icons.IconReportAnalytics,
            breadcrumbs: false
        }
    ]
};

const management = {
    id: 'management',
    title: 'User Management',
    type: 'group',
    children: [
        {
            id: 'user-directory',
            title: 'User Directory',
            type: 'collapse',
            icon: icons.IconUsers,
            children: [
                { id: 'vendors', title: 'Vendors', type: 'item', url: `${prefix}/vendors`, permission: 'manage_vendors' },
                { id: 'customers', title: 'Customers', type: 'item', url: `${prefix}/customers`, permission: 'manage_users' },
                { id: 'riders', title: 'Riders', type: 'item', url: `${prefix}/riders`, permission: 'manage_riders' },
                // { id: 'vendor-staffs', title: 'Vendor Staff', type: 'item', url: `${prefix}/vendor-staffs`, permission: 'manage_staffs' },
                {
                    id: 'platform-employees',
                    title: 'Platform Employees',
                    type: 'item',
                    url: `${prefix}/platform-employees`,
                    permission: 'manage_admins'
                }
            ]
        },
        {
            id: 'inventory-config',
            title: 'Catalogue Config',
            type: 'collapse',
            icon: icons.IconHierarchy,
            children: [
                {
                    id: 'MarketCategories',
                    title: 'Market Segments',
                    type: 'item',
                    url: `${prefix}/market-categories`,
                    permission: 'manage_categories'
                },
                {
                    id: 'ProductCategories',
                    title: 'Product Categories',
                    type: 'item',
                    url: `${prefix}/product-categories`,
                    permission: 'manage_categories'
                }
            ]
        },
        {
            id: 'vehicle-fleet',
            title: 'Vehicle Fleet',
            type: 'item',
            url: `${prefix}/vehicle-types`,
            icon: icons.IconCar,
            breadcrumbs: false,
            permission: 'manage_riders'
        }
    ]
};

const operations = {
    id: 'operations',
    title: 'Operations',
    type: 'group',
    children: [
        {
            id: 'order-mgt',
            title: 'Order Tracking',
            type: 'collapse',
            icon: icons.IconReceipt2,
            children: [
                { id: 'orders', title: 'Recent Orders', type: 'item', url: `${prefix}/orders`, permission: 'manage_orders' },
                {
                    id: 'logistics',
                    title: 'Live Logistics',
                    type: 'item',
                    url: `${prefix}/logistics`,
                    icon: icons.IconTruckDelivery,
                    permission: 'manage_orders'
                }
            ]
        },
        {
            id: 'financial-mgt',
            title: 'Financial Flows',
            type: 'collapse',
            icon: icons.IconWallet,
            children: [
                {
                    id: 'transactions',
                    title: 'Transaction Logs',
                    type: 'item',
                    url: `${prefix}/transactions`,
                    permission: 'manage_finance'
                },
                {
                    id: 'payoutRequests',
                    title: 'Settlement Requests',
                    type: 'item',
                    url: `${prefix}/payouts`,
                    permission: 'manage_finance'
                },
                {
                    id: 'promotions',
                    title: 'Campaigns & Deals',
                    type: 'item',
                    url: `${prefix}/promotions`,
                    icon: icons.IconTicket,
                    permission: 'manage_promotions'
                }
            ]
        }
    ]
};

const support = {
    id: 'support-audit',
    title: 'Support & Audit',
    type: 'group',
    children: [
        {
            id: 'help-desk',
            title: 'Customer Care',
            type: 'collapse',
            icon: icons.IconMessageReport,
            children: [
                { id: 'complaints', title: 'Ticket System', type: 'item', url: `${prefix}/complaints`, permission: 'manage_support' },
                {
                    id: 'banners',
                    title: 'Banner Mgt',
                    type: 'item',
                    url: `${prefix}/banners`,
                    icon: icons.IconLayoutCards,
                    permission: 'manage_banners'
                },
                {
                    id: 'messaging',
                    title: 'Broadcast Messaging',
                    type: 'item',
                    url: `${prefix}/messaging`,
                    icon: icons.IconSpeakerphone,
                    permission: 'manage_notifications'
                }
            ]
        },
        {
            id: 'system-audit',
            title: 'Risk & Integrity',
            type: 'collapse',
            icon: icons.IconShieldCheck,
            children: [
                { id: 'kyc-board', title: 'Verification Hub', type: 'item', url: `${prefix}/kyc`, permission: 'manage_kyc' },
                {
                    id: 'audit-logs',
                    title: 'System Logs',
                    type: 'item',
                    url: `${prefix}/audit-logs`,
                    icon: icons.IconArchive,
                    permission: 'manage_logs'
                }
            ]
        }
    ]
};

const adminMenuItems = [dashboard, management, operations, support];

export default adminMenuItems;
